exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-button-prev[data-v-106e5010],\n.swiper-button-next[data-v-106e5010] {\n  color: #ffffff;\n  text-shadow: 1px 1px 1px black;\n}\n.contatore-immagini[data-v-106e5010] {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  color: #ffffff;\n  z-index: 10;\n  text-shadow: 1px 1px 1px black;\n}\n.pointer[data-v-106e5010] {\n  cursor: pointer;\n}\n.swiper-image[data-v-106e5010] {\n  height: 300px;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n}", ""]);

// exports
